import Hotboard from "components/Briefing/tables/hotboard";
import { useState } from "react";
import { useSelector } from 'react-redux';
import { Collapse } from "reactstrap";
import ReservationsTable from "components/DriverReservations/table";
import CriticalDrivers from "./tables/criticalDrivers";
import LoadPlanningHeadTable from "./tables/loadPlanningHead";
import MiscNotes from "./tables/miscNotes";
import ActiveTransitPartials from "./tables/newTransitPartials";
import PreloadedTrailers from "./tables/preloadedTrailers";
import QuotingBriefing from "./tables/quotingHead";
import RadicalRadar from "./tables/radicalRadar";
import TrackAndTraceBriefing from "./tables/trackAndTraceHead";
import TransferAssignmentsBoard from "./transferAssignmentsBoard";
import UnconfimedDeliveryTimesBoard from "./unconfirmedDeliveryTimesBoard";
import OrdersWithChangedUnitsBoard from "./ordersWithChangedUnitsBoard";
import ShiftSelector from "./subcomponents/ShiftSelector";

const CurrentBriefing = () => {
    const briefing = useSelector((state) => state.briefing.line);
    const [openSections, setOpenSections] = useState({
        Bulletin: true,
        Quoting: false,
        TrackAndTrace: false,
        LoadPlanning: false,
    });


    return (
        <>
            <div className="main-container">
                <div className="pulse-section pt-0 mt-3">
                    <div className="pulse-header">
                        <h1>Bulletin</h1>
                        <button
                            className="button section-toggle"
                            onClick={() => setOpenSections({ ...openSections, Bulletin: !openSections.Bulletin })}
                        >
                            <i className={`fa ${openSections.Bulletin ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                        </button>
                    </div>
                    <div className="pulse-body">
                        <p className="text-muted">General briefings:- Hotboard, Radical Radar, Miscellaneous Notes, Available Drivers, Orders with Changed Vehicle Size</p>
                        <hr />
                        <Collapse isOpen={openSections.Bulletin}>
                            <Hotboard />
                            <RadicalRadar />
                            <MiscNotes />
                            <CriticalDrivers />
                            <ReservationsTable />
                            <hr />
                            <OrdersWithChangedUnitsBoard />
                        </Collapse>
                    </div>
                </div>

                <hr />

                <div className="pulse-section pt-0 mt-3">
                    <div className="pulse-header">
                        <h1>Quoting</h1>
                        <button
                            className="button section-toggle"
                            onClick={() => setOpenSections({ ...openSections, Quoting: !openSections.Quoting })}
                        >
                            <i className={`fa ${openSections.Quoting ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                        </button>
                    </div>
                    <div className="pulse-body">
                        <p className="text-muted">Quoting team briefing</p>
                        <hr />
                        <Collapse isOpen={openSections.Quoting}>
                            <QuotingBriefing />
                        </Collapse>
                    </div>
                </div>

                <hr />

                <div className="pulse-section pt-0 mt-3">
                    <div className="pulse-header">
                        <h1>Track &Trace</h1>
                        <button
                            className="button section-toggle"
                            onClick={() => setOpenSections({ ...openSections, TrackAndTrace: !openSections.TrackAndTrace })}
                        >
                            <i className={`fa ${openSections.TrackAndTrace ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                        </button>
                    </div>
                    <div className="pulse-body">
                        <p className="text-muted">Track &Trace briefings:- Orders with Unconfirmed Delivery Times</p>
                        <hr />
                        <Collapse isOpen={openSections.TrackAndTrace}>
                            <TrackAndTraceBriefing />
                            <hr />
                            <UnconfimedDeliveryTimesBoard />
                        </Collapse>
                    </div>
                </div>

                <hr />

                <div className="pulse-section pt-0 mt-3">
                    <div className="pulse-header">
                        <h1>Load Planning</h1>
                        <button
                            className="button section-toggle"
                            onClick={() => setOpenSections({ ...openSections, LoadPlanning: !openSections.LoadPlanning })}
                        >
                            <i className={`fa ${openSections.LoadPlanning ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                        </button>
                    </div>
                    <div className="pulse-body">
                        <p className="text-muted">Load Planning team briefing:- Preloaded Trailers, Transit Partials, Transfer Assignments</p>
                        <hr />
                        <Collapse isOpen={openSections.LoadPlanning}>
                            <PreloadedTrailers />
                            <ActiveTransitPartials />
                            <LoadPlanningHeadTable />
                            <hr />
                            <TransferAssignmentsBoard />
                        </Collapse>
                    </div>
                </div>

                <hr />

            </div>
            {briefing === 'Briefings' && (
                <ShiftSelector />
            )}
        </>
    );
};

export default CurrentBriefing;
